import { buttonComponentProps } from '../../utils/component';
import { ButtonProps } from './button.types';

export const buttonProps = (props: ButtonProps): string => {
  const {
    color = 'primary',
    disabled = false,
    rounded = false,
    small = false
  } = props;

  const defaultProps =
    buttonComponentProps[color] ?? buttonComponentProps['primary'];
  const disabledProps = disabled
    ? `${buttonComponentProps['disabled']} ${
        color.includes('Link') ? 'tw-border-0 hover:tw-text-gray-300' : ''
      }`
    : '';
  const roundedProps = rounded
    ? buttonComponentProps['rounded']
    : 'tw-rounded-md';
  const smallProps = small
    ? 'tw-text-base tw-px-2 tw-py-1'
    : 'tw-text-base tw-p-3';

  return `${smallProps} ${defaultProps} ${disabledProps} ${roundedProps}`;
};
